import api from '../api'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { ApiRouteEnum } from '../../enums/ApiRouteEnum'
import { IContractUploadData } from '../../interfaces/entities/IContractUploadData'

export const usePostContractUploadDocument = (
  successCallBack: (data: any) => void,
  errorCallBack: (data: any) => void,
) => {
  const queryClient = useQueryClient()
  return useMutation((contractUploadData: IContractUploadData) => api.post(ApiRouteEnum.CONTRACT_UPLOAD_DOCUMENT, contractUploadData), {
    mutationKey: [ApiRouteEnum.CONTRACT_UPLOAD_DOCUMENT],
    onSuccess: (data) => {
      successCallBack(data.data)
      queryClient.invalidateQueries([ApiRouteEnum.CONTRACT])
    },
    onError: (error) => errorCallBack(error),
  })
}
